// Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="google.maps" />

import { inject, Injectable } from '@angular/core';
import { ApiService } from '@us/web/shared/data-access';

@Injectable({
    providedIn: 'root'
})
export class GoogleMapsService {
    private readonly apiService = inject(ApiService);

    public getGeocode(params: { lat: number; lng: number } | { address: string }) {
        return this.apiService.get<google.maps.GeocoderResponse>(`google-maps/geocode`, { params });
    }

    /** @deprecated */
    public autocomplete(params: { input: string }) {
        return this.apiService.get<google.maps.places.AutocompleteResponse>(`google-maps/autocomplete`, { params });
    }
}
